export const routes = {
  home: "/",
  category: "/category/:path",
  product: "/product/:productId",
  user: "/user/*",
  cart: "/cart",
  checkout: "/checkout",
};
